import { Injectable } from '@angular/core';
import {
  ACCOUNT_RECOVERY_PAGES,
  LINKS,
  LOGIN_MODAL,
  VIEW_PAGE
} from '@com-delta-idp/mnx-sitewide-shared-core-smart';
import { VIEW_NAME } from '../../data-access/login-modal/constants/login-constant';
import { LoginModalHelperSuperSupportComponent } from './login-modal-helper-super-support.component';
@Injectable({
  providedIn: 'root'
})
export class LoginModalSuperHelperComponent extends LoginModalHelperSuperSupportComponent {
  loginScreen(viewName: string, viewPage: string): void {
    let name = '';
    let button = false;
    name = this.checkNameRedirectionLinks(viewName, name);
    if (viewName.toLocaleLowerCase() === VIEW_PAGE.JOIN_SKYMILES) {
      name = LOGIN_MODAL.JOIN_SKYMILES;
      button = true;
    }
    if (viewName.toLocaleLowerCase() === VIEW_PAGE.LOG_IN) {
      name = LOGIN_MODAL.LOG_IN;
      button = true;
    }
    this.adobeDatalayerService.updateAnalyticsLoginModal(
      name,
      viewPage,
      button
    );
  }

  unlockYourAccountOrLoginHelpPage(viewName: string, viewPage: string): void {
    let name = '';
    if (viewName.toLocaleLowerCase() === VIEW_PAGE.FORGOT_PASSWORD) {
      name = LOGIN_MODAL.RESET_PASSWORD;
    }
    if (viewName.toLocaleLowerCase() === VIEW_PAGE.LOGIN_HELP) {
      name = LOGIN_MODAL.LOGIN_HELP;
    }
    if (viewName.toLocaleLowerCase() === VIEW_PAGE.FORGOT_LOGIN) {
      name = LOGIN_MODAL.SEND_LOGIN;
    }
    this.adobeDatalayerService.updateAnalyticsLoginModal(name, viewPage, true);
  }

  resetPasswordPage(viewName: string, viewPage: string): void {
    let name = '';
    if (viewName.toLocaleLowerCase() === VIEW_PAGE.FORGOT_PASSWORD) {
      name = LOGIN_MODAL.LOG_IN;
    }
    if (viewName.toLocaleLowerCase() === VIEW_PAGE.SECURITY_QUESTIONS) {
      name = LOGIN_MODAL.SECURITY_QUESTIONS;
    }
    if (viewName.toLocaleLowerCase() === VIEW_PAGE.CHECK_YOUR_EMAIL) {
      name = LOGIN_MODAL.CHECK_YOUR_EMAIL;
    }
    this.adobeDatalayerService.updateAnalyticsLoginModal(name, viewPage, true);
  }

  forgotLoginPage(viewPage: string): void {
    const name = VIEW_PAGE.CONTINUE;
    this.adobeDatalayerService.updateAnalyticsLoginModal(name, viewPage, true);
  }

  checkNameRedirectionLinks(viewName: string, name: string): string {
    name = this.checkNameAlertLinks(viewName, name);
    if (viewName.toLocaleLowerCase() === VIEW_PAGE.FORGOT_LOGIN) {
      name = LOGIN_MODAL.FORGOT_LOGIN;
    }
    if (viewName.toLocaleLowerCase() === VIEW_PAGE.FORGOT_PASSWORD) {
      name = LOGIN_MODAL.FORGOT_PASSWORD;
    }
    return name;
  }

  checkNameAlertLinks(viewName: string, name: string): string {
    if (viewName.toLocaleLowerCase() === VIEW_PAGE.NEED_HELP) {
      name = LOGIN_MODAL.LOGIN_HELP;
    }
    if (viewName.toLocaleLowerCase() === VIEW_PAGE.MY_TRIPS) {
      name = LOGIN_MODAL.MY_TRIPS;
    }
    return name;
  }

  trackAnalytics(viewName: string, pageSection: string): void {
    if (pageSection === VIEW_NAME.LOGIN_CREDENTIALS_SCREEN) {
      const viewPage = this.checkLoginPage();
      this.loginScreen(viewName, viewPage);
    }
    if (pageSection === VIEW_NAME.FORGOT_LOGIN_SCREEN) {
      this.forgotLoginPage(ACCOUNT_RECOVERY_PAGES.FORGOT_LOGIN);
    }
    this.checkUnlockOrHelpPage(viewName, pageSection);
  }

  checkUnlockOrHelpPage(viewName: string, pageSection: string): void {
    if (pageSection === VIEW_NAME.UNLOCK_ACCOUNT_SCREEN) {
      this.unlockYourAccountOrLoginHelpPage(
        viewName,
        ACCOUNT_RECOVERY_PAGES.UNLOCK_ACCOUNT
      );
    }
    if (pageSection === VIEW_NAME.LOGIN_HELP_SCREEN) {
      this.unlockYourAccountOrLoginHelpPage(
        viewName,
        ACCOUNT_RECOVERY_PAGES.LOGIN_HELP
      );
    }
    if (pageSection === VIEW_NAME.CHECK_YOUR_EMAIL_SCREEN) {
      this.forgotLoginPage(ACCOUNT_RECOVERY_PAGES.CHECK_YOUR_EMAIL);
    }
    this.checkResetPasswordPage(viewName, pageSection);
  }

  checkResetPasswordPage(viewName: string, pageSection: string): void {
    if (
      pageSection === VIEW_NAME.NEW_RESET_PASSWORD_CHECK_YOUR_EMAIL_SCREEN ||
      pageSection === VIEW_NAME.SECURITY_QUESTION_ANSWER_SCREEN
    ) {
      this.resetPasswordPage(viewName, ACCOUNT_RECOVERY_PAGES.RECOVERY_METHOD);
    }
    if (pageSection === VIEW_NAME.RESET_PASSWORD_SCREEN) {
      this.resetPasswordPage(viewName, ACCOUNT_RECOVERY_PAGES.RESET_PASSWORD);
    }
  }

  checkLoginPage(): string {
    return this.facade.standalonePage
      ? ACCOUNT_RECOVERY_PAGES.STANDALONE
      : this.router.url.endsWith(LINKS.SEATS_URL)
      ? ACCOUNT_RECOVERY_PAGES.CENTER_PAGE
      : ACCOUNT_RECOVERY_PAGES.GLOBAL_HEADER;
  }
}
